import script from "./pazienteBaseEdit.vue?vue&type=script&setup=true&lang=ts"
export * from "./pazienteBaseEdit.vue?vue&type=script&setup=true&lang=ts"

import "./pazienteBaseEdit.vue?vue&type=style&index=0&id=2cbc7d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cbc7d5a"]])

export default __exports__